import { useMemo } from 'react';

import {
  useIsCommunityDraftPostEnabled,
  useIsPostOnBehalfOfDraftEnabled,
  useIsQuestionsOnlyMode,
  useIsStorylineDraftPostEnabled,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useDraftPostSettings: UseMainUIFeatureSettings<'draftPost'> = (options) => {
  const draftPostOverrides = options?.overrides?.draftPost;
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();

  const isStorylineDraftPostEnabled = useIsStorylineDraftPostEnabled();
  const isCommunityDraftPostEnabled = useIsCommunityDraftPostEnabled();
  const isPostOnBehalfOfDraftEnabled = useIsPostOnBehalfOfDraftEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        isStorylineDraftPostEnabled: false,
        isCommunityDraftPostEnabled: false,
        isPostOnBehalfOfDraftEnabled: false,
        ...draftPostOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isStorylineDraftPostEnabled || isCommunityDraftPostEnabled,
      isStorylineDraftPostEnabled,
      isCommunityDraftPostEnabled,
      isPostOnBehalfOfDraftEnabled,
      ...draftPostOverrides,
    };
  }, [
    isQuestionsOnlyMode,
    isStorylineDraftPostEnabled,
    isCommunityDraftPostEnabled,
    isPostOnBehalfOfDraftEnabled,
    draftPostOverrides,
  ]);
};
